import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://1950a6356127ec6ad4ae78ffc2708f97@o4507401449046016.ingest.de.sentry.io/4508756873707600",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()